export interface Hub {
    id: number
    name: string
    normalized_name: string
    type: number
    niche: number
    country: string
    state: number
    lga: number
    instructor_id: number
    subscription_start: string
    subscription_end: string
}

export function newHub(): Hub {
    return {
        id: 0,
        name: '',
        normalized_name: '',
        type: 0,
        niche: 0,
        country: 'NG',
        state: 0,
        lga: 0,
        instructor_id: 0,
        subscription_start: '',
        subscription_end: ''
    };
}

export function createHubPayload(hub: Hub) {
    return {
        name: hub.name,
        type: hub.type,
        niche: hub.niche,
        country: hub.country,
        state: hub.state,
        lga: hub.lga,
    }
}

export function updateHubPayload(hub: Hub) {
    return {
        id: hub.id,
        name: hub.name,
        type: hub.type,
        niche: hub.niche,
        country: hub.country,
        state: hub.state,
        lga: hub.lga,
    }
}